export const availableInboxApps = {
    GMAIL: "GMAIL",
    TWITTER: "TWITTER",
    FACEBOOK: "FACEBOOK_MESSENGER",
};
